export const IMAGE_SELECTOR = 'ws-media-container';
